/**
 * @generated SignedSource<<48093823192a6635e697d04e89bc87ea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountLogOutMutation$variables = Record<PropertyKey, never>;
export type AccountLogOutMutation$data = {
  readonly logOut: {
    readonly ok: boolean;
  };
};
export type AccountLogOutMutation = {
  response: AccountLogOutMutation$data;
  variables: AccountLogOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LogOutPayload",
    "kind": "LinkedField",
    "name": "logOut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountLogOutMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountLogOutMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "64194d095e91d753160542a7613fe092",
    "id": null,
    "metadata": {},
    "name": "AccountLogOutMutation",
    "operationKind": "mutation",
    "text": "mutation AccountLogOutMutation {\n  logOut {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fc72efeb606899db3ec265485979500";

export default node;
